var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userinfo"},[_c('el-avatar',{attrs:{"size":"large","shape":"square","src":_vm.userInfo.avatar}}),_c('div',{},[_c('span',[_vm._v("学员ID: "+_vm._s(_vm.userInfo.id))]),_c('span',[_vm._v(_vm._s(_vm.userInfo.nickname))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }